import {Component, OnInit} from '@angular/core';
import {User} from '@models/user';
import {CommonService} from '@services/common.service';
import {EMPTY_USER} from '@models/empty';
import {UserService} from '@services/user.service';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {MatDialog} from '@angular/material/dialog';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

    user: User = Object.assign({}, EMPTY_USER);

    constructor(
        public commonService: CommonService,
        private userService: UserService,
        public dialog: MatDialog,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService) {
    }

    ngOnInit(): void {
        this.user = this.authenticationService.currentUser;
    }

    editFiscal(event) {
        if (this.user.fiscal_choice == "SCI IS" && !this.authenticationService.isAllowed('essentiel')) {
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel: 'assets/upgrade/is.png', plan: 'Essentiel', feature: 'Fiscalité en ' + this.user.fiscal_choice}
            });
            this.user.fiscal_choice = 'SCI IR';
        } else if (this.user.fiscal_choice != 'Foncier forfait' && (this.user.pro_plan == '' && (this.user.plan == 'trial' || this.user.plan == ''))) {
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel: 'assets/upgrade/is.png', plan: 'Essentiel', feature: 'Fiscalité en ' + this.user.fiscal_choice}
            });
            this.user.fiscal_choice = 'Foncier forfait';
        } else {
            this.edit(event)
        }
    }

    edit(event) {
        this.userService.updateSettings(this.user);
    }
}
